import React from 'react';
import { Text } from '@mantine/core';
import { IconCheck } from '@tabler/icons-react';

const STEPS = [
  { label: 'School Setup', description: 'Teacher & school info' },
  { label: 'Students', description: 'Roster & solos' },
  { label: 'Ensembles', description: 'Group pieces' },
  { label: 'Confirmation', description: 'Review & finalize' }
];

const SchoolProgressStepper = ({ currentStep }) => {
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '1.5rem 2rem',
      background: 'white',
      borderBottom: '1px solid #eee'
    }}>
      {STEPS.map((step, index) => {
        const stepNum = index + 1;
        const isCompleted = stepNum < currentStep;
        const isActive = stepNum === currentStep;

        return (
          <React.Fragment key={stepNum}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', minWidth: '100px' }}>
              <div style={{
                width: '36px',
                height: '36px',
                borderRadius: '50%',
                background: isCompleted
                  ? 'linear-gradient(135deg, var(--primary-gold), var(--deep-gold))'
                  : isActive
                    ? 'linear-gradient(135deg, var(--primary-gold), var(--deep-gold))'
                    : '#e9ecef',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginBottom: '6px',
                border: isActive && !isCompleted ? '2px solid var(--deep-gold)' : 'none',
                transition: 'all 0.3s ease'
              }}>
                {isCompleted
                  ? <IconCheck size={18} color="white" />
                  : <Text size="sm" fw={700} color={isActive ? 'white' : 'dimmed'}>{stepNum}</Text>
                }
              </div>
              <Text size="xs" fw={isActive ? 700 : 400} color={isActive ? 'var(--primary-gold)' : 'dimmed'} ta="center">
                {step.label}
              </Text>
            </div>

            {index < STEPS.length - 1 && (
              <div style={{
                flex: 1,
                height: '2px',
                background: isCompleted ? 'var(--primary-gold)' : '#e9ecef',
                margin: '0 8px',
                marginBottom: '20px',
                transition: 'background 0.3s ease'
              }} />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default SchoolProgressStepper;
